import { render, staticRenderFns } from "./TeacherCourseCodeAssignmentView.vue?vue&type=template&id=03d69d7c&scoped=true"
import script from "./TeacherCourseCodeAssignmentView.vue?vue&type=script&lang=js"
export * from "./TeacherCourseCodeAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseCodeAssignmentView.vue?vue&type=style&index=0&id=03d69d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d69d7c",
  null
  
)

export default component.exports